import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IMessagesMeta{
  bank: FormInputMeta;
  startDate: FormInputMeta;
  endDate: FormInputMeta;
  
  schema: any,
}

const MessagesMeta: IMessagesMeta = {} as IMessagesMeta;

MessagesMeta.bank = commonFormMeta.bank;
MessagesMeta.startDate = commonFormMeta.startDate;
MessagesMeta.endDate = commonFormMeta.endDate;



MessagesMeta.schema = yup.object().shape(getValidationSchema(MessagesMeta));

export default MessagesMeta;

